export default __webpack_public_path__ + "static/media/eth_logo.04b20b95.svg";